/**
 * `subscription_cta_enabled`, `fees_modal_disabled`, `ai_advisor`, and
 * `sort_by_default` were migrated out of subscription config into other
 * fields server-side but can still show up in older config payloads.
 */
export const LEGACY_SUBSCRIPTION_CONFIG_KEYS = [
  "subscription_cta_enabled",
  "fees_modal_disabled",
  "ai_advisor",
  "sort_by_default"
] as const

/** Drops the legacy keys from a subscription config read from the API. */
export const stripLegacySubscriptionConfigKeys = (
  config: Record<string, unknown>
): Record<string, unknown> => {
  const rest = { ...config }
  LEGACY_SUBSCRIPTION_CONFIG_KEYS.forEach(key => {
    delete rest[key]
  })
  return {
    ...rest,
    dashboard_config: rest.dashboard_config || {}
  }
}

/** Strips the legacy keys, then explicitly nulls them so the backend clears any stored values on save. */
export const nullifyLegacySubscriptionConfigKeys = (
  config: Record<string, unknown>
): Record<string, unknown> => {
  const cleaned = stripLegacySubscriptionConfigKeys(config)
  const nulled: Record<string, unknown> = { ...cleaned }
  LEGACY_SUBSCRIPTION_CONFIG_KEYS.forEach(key => {
    nulled[key] = null
  })
  return nulled
}
